<template>
  <div>
    <van-nav-bar
      :title="$t('app.agent_transfer_withdrawal.title')"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/agency')"
    />
    <van-form>
      <van-cell :title="$t('app.agent_transfer_withdrawal.accBalance')">
        <template #default>
          <span>{{ agent_account }}{{$t("app.common.currency")}}</span>
        </template>
      </van-cell>
      <van-field
        v-model="money"
        error
        required
        type="digit"
        :placeholder="$t('app.agent_transfer_withdrawal.transferAm_placeholder')"
        input-align="right"
      >
      <template #label>
       <div style="width:100px;">{{ $t("app.agent_transfer_withdrawal.transferAm") }}</div> 
      </template>
      </van-field>
      <van-row>
          <van-col span="2"></van-col>
          <van-col span="9">
              <van-button size="small" round  type="danger" block @click="withdrawalMoney" class="black">{{$t("app.agent_transfer_withdrawal.withdraw")}}</van-button>
          </van-col>
          <van-col span="2"></van-col>
          <van-col span="9">
              <van-button size="small" round  type="danger" block @click="transferMoney" class="black">{{$t("app.agent_transfer_withdrawal.transfer")}}</van-button>
          </van-col> 
          <van-col span="2"></van-col>
      </van-row>
      <van-row>
        <van-col span="24">
          <p class="transferWithdrawalText">{{ $t("app.agent_transfer_withdrawal.dsc") }}</p>
        </van-col>
      </van-row>
    </van-form>
  </div>
</template>

<script>
import { Dialog } from "vant";
    export default {
      name: "AgencyTransferWithdrwal",
      data(){
        return{
          agent_account:'',
          money:'',
        }
      },
      methods:{
        isLogin(){
          let that = this;
          if (!that.$store.state.loginType){
            that.$router.push('/login')
          }
        },
        transferMoney(){
            let that = this;
            if(!that.money){
              that.$toast.fail(this.$t('app.agent_transfer_withdrawal.warn1'));
            }else{
            Dialog.confirm({
              title: this.$t('app.agent_transfer_withdrawal.transfer_title'),
              message:
                this.$t('app.agent_transfer_withdrawal.transfer_sure')+that.money+ this.$t('app.agent_transfer_withdrawal.transfer_sure1'),
              cancelButtonText: this.$t('app.common.cancel'),
              confirmButtonText: this.$t('app.common.confirm'),
            })
              .then(() => {
                that.transfer();
              })
              .catch(() => {});
            }
        },
        withdrawalMoney(){
            let that = this;
            if(!that.money){
              that.$toast.fail(this.$t('app.agent_transfer_withdrawal.warn1'));
            }else{
            Dialog.confirm({
              title: this.$t('app.agent_transfer_withdrawal.withdraw_title'),
              message:
                this.$t('app.agent_transfer_withdrawal.withdraw_sure')+that.money+"?",
              cancelButtonText: this.$t('app.common.cancel'),
              confirmButtonText: this.$t('app.common.confirm'),
            })
              .then(() => {
                that.Withdrawal();
              })
              .catch(() => {});
            }
        },
        getUser() {
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "user",
                token: sessionStorage.getItem("token")
              }
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.code === 1) {
                that.agent_account = resData.data.agent_account;
              } else if (res.data.code === 0 || res.data.code === -1) {
                that.$toast.fail(that.$t(resData.msg));
              }
            })
            .catch(()=>{
              that.$toast.fail(that.$NoNetworkErrorMsg)
            })
        },
        transfer(){
          let that = this;
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "transfer_money",
              token: sessionStorage.getItem("token"),
              number: that.money,
            }
          })
            .then(function(res) {
              if (res.data.code == 1) {
                that.$toast.success({
                  message: that.$t(res.data.msg),
                  onClose:function () {
                    that.$router.push('/member/agency')
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(that.$t(res.data.msg));
              }
            })
            .catch(()=>{
              that.$toast.fail(that.$NoNetworkErrorMsg)
            })

        },
        Withdrawal() {
        let that = this;
        that.$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "accountbank",
            token: sessionStorage.getItem("token")
          }
        })
          .then(function(res) {
            if (res.data.code == 1) {
              let resData = res.data;
              if (resData.data.length === 0){
                that.$toast({
                  type:'fail',
                  message:that.$t('app.agency_transfer_withdrawal.bind_bank'),
                  onClose:function () {
                    that.$router.push('/member/information');
                  }
                });
              }else{
                let bankCardList = res.data.data;
                // that.bankCardList = res.data.data;
                let card = bankCardList[0].card;
                let name = bankCardList[0].name;

                that.$http({
                  url: "/",
                  method: "post",
                  data: {
                    nozzle: "agent_dowithdraw",
                    token: sessionStorage.getItem("token"),
                    number: that.money,
                    password: that.password,
                    name: name,
                    card: card
                  }
                })
                  .then(function(res) {
                    if (res.data.code == 1) {
                      that.$toast.success({
                        message: that.$t(res.data.msg),
                        onClose:function () {
                          that.$router.push('/member/agency')
                        }
                      });
                    } else if (res.data.code == 0 || res.data.code == -1) {
                      that.$toast.fail(that.$t(res.data.msg));
                    }
                  });
              }


            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(that.$t(res.data.msg));
            }
          })
          .catch(()=>{
              that.$toast.fail(that.$NoNetworkErrorMsg)
          })

      }
      },
      mounted:function () {
        this.isLogin();
        this.getUser();
      }
    }
</script>

<style scoped>
.black{
    color: #ffffff;
}
.transferWithdrawalText{
    padding-left:15px;
    padding-right:15px;
    font-size:12px;
}
</style>



// WEBPACK FOOTER //
// src/components/AgencyTransferWithdrawal.vue